import type { ProteinCalcProduct } from '@bulknutrients/bulk-shared-lib/interfaces/ProteinCalculator';
import { CustomImage } from '@components/Media/Image';
import Link from 'next/link';
import type { ReactElement } from 'react';
import { round } from './ProductProperties';

export function Product({
  product,
  remove,
}: {
  product: ProteinCalcProduct;
  remove: (sku: string) => void;
  comparisonProduct?: ProteinCalcProduct;
  purest: string;
}): ReactElement {
  return (
    <article className="min-w-auto flex flex-col tiny:min-w-[160px]">
      <header className="grow-1 basis-auto bg-white p-[2vmin] text-center shadow-inner dark:bg-grey-darkest">
        <button
          className="relative z-2 mx-auto my-0 -mb-[4vmin] flex h-8
          cursor-pointer items-center justify-center rounded border-none bg-grey-darkest px-4 py-0
          font-bold uppercase tracking-wider text-white shadow-[rgba(0,0,0,0.15)_0_2px_5px,rgba(0,0,0,0.1)_0_1px_2px]
          duration-200
          hover:scale-[1.075] hover:outline-hidden"
          onClick={() => remove(product.sku)}
          type="button"
        >
          Swap
        </button>
        {product.image && (
          <CustomImage
            alt={`Bulk Nutrients ${product.name} package`}
            image={product.image}
            width={140}
            height={160}
          />
        )}
        <h2 className="m-0 mb-1 p-3 text-center text-orange">
          <Link
            prefetch={process.env.NEXT_PUBLIC_PREFETCH === 'true'}
            href={product.slug}
            target="_blank"
            itemProp="name"
            rel="noreferrer"
            className="text-inherit no-underline font-secondary text-3xl uppercase leading-1"
          >
            {product.name}
          </Link>
        </h2>
        <div className="mb-2 dark:text-grey-light">
          <span
            className="text-[1.125rem] font-bold tracking-wider"
            itemProp="weight"
            itemScope
            itemType="http://schema.org/QuantitativeValue"
          >
            {product.displayWeight}
          </span>{' '}
          for{' '}
          <span itemProp="offers" itemScope itemType="http://schema.org/Offer">
            <span
              itemProp="price"
              className="text-[1.125rem] font-bold tracking-wider"
            >
              ${round((product.price as number) / 100)}
            </span>
          </span>
        </div>
        <div
          itemProp="description"
          className="relative overflow-hidden text-ellipsis whitespace-pre-wrap text-black-mid
          dark:text-grey-light"
        >
          {product.description}
        </div>
      </header>
    </article>
  );
}
